"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientReadyState = exports.RefreshResult = exports.ClientCacheState = exports.OverrideBehaviour = exports.User = exports.SettingKeyValue = exports.Comparator = exports.SettingType = exports.FormattableLogMessage = exports.LogLevel = exports.DataGovernance = exports.PollingMode = exports.MapOverrideDataSource = exports.FlagOverrides = exports.ExternalConfigCache = exports.FetchError = exports.FetchResult = exports.FetchStatus = exports.createConsoleLogger = exports.disposeAllClients = exports.getClient = void 0;
var ConfigCatClient_1 = require("./ConfigCatClient");
var ConfigCatClientOptions_1 = require("./ConfigCatClientOptions");
Object.defineProperty(exports, "PollingMode", { enumerable: true, get: function () { return ConfigCatClientOptions_1.PollingMode; } });
var ConfigCatLogger_1 = require("./ConfigCatLogger");
Object.defineProperty(exports, "LogLevel", { enumerable: true, get: function () { return ConfigCatLogger_1.LogLevel; } });
var Polyfills_1 = require("./Polyfills");
Polyfills_1.setupPolyfills();
/**
 * Returns an instance of `ConfigCatClient` for the specified SDK Key.
 * @remarks This method returns a single, shared instance per each distinct SDK Key.
 * That is, a new client object is created only when there is none available for the specified SDK Key.
 * Otherwise, the already created instance is returned (in which case the `pollingMode`, `options` and `configCatKernel` arguments are ignored).
 * So, please keep in mind that when you make multiple calls to this method using the same SDK Key, you may end up with multiple references to the same client object.
 * @param sdkKey SDK Key to access the ConfigCat config.
 * @param pollingMode The polling mode to use.
 * @param options Options for the specified polling mode.
 */
function getClient(sdkKey, pollingMode, options, configCatKernel) {
    return ConfigCatClient_1.ConfigCatClient.get(sdkKey, pollingMode, options, configCatKernel);
}
exports.getClient = getClient;
/**
 * Disposes all existing `ConfigCatClient` instances.
 */
function disposeAllClients() {
    ConfigCatClient_1.ConfigCatClient.disposeAll();
}
exports.disposeAllClients = disposeAllClients;
/**
 * Creates an instance of `ConfigCatConsoleLogger`.
 * @param logLevel Log level (the minimum level to use for filtering log events).
 */
function createConsoleLogger(logLevel) {
    return new ConfigCatLogger_1.ConfigCatConsoleLogger(logLevel);
}
exports.createConsoleLogger = createConsoleLogger;
var ConfigFetcher_1 = require("./ConfigFetcher");
Object.defineProperty(exports, "FetchStatus", { enumerable: true, get: function () { return ConfigFetcher_1.FetchStatus; } });
Object.defineProperty(exports, "FetchResult", { enumerable: true, get: function () { return ConfigFetcher_1.FetchResult; } });
Object.defineProperty(exports, "FetchError", { enumerable: true, get: function () { return ConfigFetcher_1.FetchError; } });
var ConfigCatCache_1 = require("./ConfigCatCache");
Object.defineProperty(exports, "ExternalConfigCache", { enumerable: true, get: function () { return ConfigCatCache_1.ExternalConfigCache; } });
var FlagOverrides_1 = require("./FlagOverrides");
Object.defineProperty(exports, "FlagOverrides", { enumerable: true, get: function () { return FlagOverrides_1.FlagOverrides; } });
Object.defineProperty(exports, "MapOverrideDataSource", { enumerable: true, get: function () { return FlagOverrides_1.MapOverrideDataSource; } });
var ConfigCatClientOptions_2 = require("./ConfigCatClientOptions");
Object.defineProperty(exports, "DataGovernance", { enumerable: true, get: function () { return ConfigCatClientOptions_2.DataGovernance; } });
var ConfigCatLogger_2 = require("./ConfigCatLogger");
Object.defineProperty(exports, "FormattableLogMessage", { enumerable: true, get: function () { return ConfigCatLogger_2.FormattableLogMessage; } });
var ProjectConfig_1 = require("./ProjectConfig");
Object.defineProperty(exports, "SettingType", { enumerable: true, get: function () { return ProjectConfig_1.SettingType; } });
Object.defineProperty(exports, "Comparator", { enumerable: true, get: function () { return ProjectConfig_1.Comparator; } });
var ConfigCatClient_2 = require("./ConfigCatClient");
Object.defineProperty(exports, "SettingKeyValue", { enumerable: true, get: function () { return ConfigCatClient_2.SettingKeyValue; } });
var RolloutEvaluator_1 = require("./RolloutEvaluator");
Object.defineProperty(exports, "User", { enumerable: true, get: function () { return RolloutEvaluator_1.User; } });
var FlagOverrides_2 = require("./FlagOverrides");
Object.defineProperty(exports, "OverrideBehaviour", { enumerable: true, get: function () { return FlagOverrides_2.OverrideBehaviour; } });
var ConfigServiceBase_1 = require("./ConfigServiceBase");
Object.defineProperty(exports, "ClientCacheState", { enumerable: true, get: function () { return ConfigServiceBase_1.ClientCacheState; } });
Object.defineProperty(exports, "RefreshResult", { enumerable: true, get: function () { return ConfigServiceBase_1.RefreshResult; } });
var Hooks_1 = require("./Hooks");
Object.defineProperty(exports, "ClientReadyState", { enumerable: true, get: function () { return Hooks_1.ClientReadyState; } });
